import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import type { PackageFormValues } from '@/views/add-package/add-package.types';
import { PreviewSectionCard } from '../PreviewSectionCard';

const ProductDetailsSection = () => {
    const { control } = useFormContext<PackageFormValues>();
    const productDetails = useWatch({
        control,
        name: 'productDetails',
        defaultValue: { name: '', description: '' },
    });

    return (
        <PreviewSectionCard title="Product Details">
            <Typography variant="body2" color="text.secondary">
                Name
            </Typography>
            <Typography variant="body1" fontWeight={600}>
                {productDetails?.name || '—'}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Description
            </Typography>
            <Typography variant="body1">
                {productDetails?.description || '—'}
            </Typography>
        </PreviewSectionCard>
    );
};

export default ProductDetailsSection;
